import { Typography } from "@mui/material";
import { useEffect } from "react";
import { BiPhone } from "react-icons/bi";
import { MdEmail, MdPlace } from "react-icons/md";

const TermOfUse = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="term-of-use-page" style={{ marginTop: "130px" }}>
            <div className="top-section bg-el">
                <div className="page-section bg-el">
                    <Typography className="heading clr-pm" variant="h3" component="h2" fontWeight={600}>
                        Terms of Use
                    </Typography>
                </div>
                {/* </div>

            <div className="top-section"> */}
                <div className="page-section">
                    <div className="">
                        <p className="">
                            The use of any product, service, or feature available through the internet website
                            accessible at www.appretive.com by any user of the Website shall be governed by the
                            following Terms of Use. These terms and conditions are deemed accepted by You upon use of
                            the Website. Please read them carefully before accessing or using any services or content
                            provided through this Website.
                        </p>
                    </div>

                    <div className="pt4 pb2">
                        <Typography variant="h5" fontWeight={600} className="">
                            General Use
                        </Typography>

                        <p className="pt2">
                            This Website is provided by Appretive Technologies Pvt. Ltd. (hereinafter referred to as
                            "Appretive"), a company incorporated under the Companies Act, 2013 of India, having its
                            registered office at surat. The Website is intended solely for informational purposes.
                        </p>

                        <p className="pt-2">
                            By accessing or using the Website, or downloading Materials from it, you agree to comply
                            with and be bound by these Terms of Use. If you do not agree with these terms, you are
                            requested not to access the Website or use any Materials.
                        </p>

                        <p className="pt2">
                            In the event of any inconsistency between these Terms of Use and additional terms specific
                            to a particular section or functionality of the Website, such additional terms shall prevail
                            for that section.
                        </p>
                    </div>

                    <div className="pt2 pb2">
                        <Typography variant="h5" fontWeight={600} className="">
                            Ownership and Intellectual Property
                        </Typography>

                        <p className="pt2">
                            All content on this Website, including but not limited to text, graphics, logos, images,
                            software, and audio/video content (excluding third-party materials), is the property of
                            Appretive or its content suppliers, and is protected by applicable intellectual property
                            laws. No content from the Website may be copied, modified, reproduced, republished,
                            uploaded, posted, transmitted, or distributed in any form without prior written permission
                            from Appretive.
                        </p>

                        <p className="pt2">
                            All trademarks, logos, and service marks displayed on the Website are the property of
                            Appretive or their respective third parties. Nothing on the Website shall be interpreted as
                            granting any license or right to use any trademark without the prior written permission of
                            Appretive or the relevant third party.
                        </p>
                    </div>

                    <div className="pt2 pb2">
                        <Typography variant="h5" fontWeight={600} className="">
                            User Conduct
                        </Typography>

                        <p className="pt2">
                            You agree to use the Website only for lawful purposes and in accordance with these Terms.
                            You must not:
                        </p>

                        <div className="pt2">
                            <li className="">
                                Attempt to gain unauthorized access to any section of the Website, other accounts, or
                                systems connected to the Website.
                            </li>
                            <li className="">
                                Upload or distribute viruses, worms, malware, or any other harmful software.
                            </li>
                            <li className="">
                                Use the Website in a manner that could damage, disable, or impair any Appretive server
                                or network.
                            </li>
                        </div>
                    </div>

                    <div className="pt2 pb2">
                        <Typography variant="h5" fontWeight={600} className="">
                            Confidentiality
                        </Typography>

                        <p className="pt2">
                            Any information or material sent to Appretive through the Website will be deemed not to be
                            confidential. By sending any information or material, you grant Appretive an unrestricted,
                            irrevocable license to use, reproduce, display, perform, modify, transmit, and distribute
                            those materials or information.
                        </p>
                    </div>

                    <div className="pt2 pb2">
                        <Typography variant="h5" fontWeight={600}>
                            Business Relationships
                        </Typography>

                        <p className="pt2">
                            Appretive maintains business relationships with customers, partners, vendors, and
                            governmental entities. For simplicity, terms such as "joint venture", "partnership", or
                            "partner" may be used on this Website. However, such terms are used generically and do not
                            imply any legal partnership unless expressly stated.
                        </p>
                    </div>

                    <div className="pt2 pb2">
                        <Typography variant="h5" fontWeight={600}>
                            Third-Party Content
                        </Typography>

                        <p className="pt2">
                            This Website may contain links to third-party websites or resources. Appretive is not
                            responsible for the content, availability, or policies of any third-party websites. Your use
                            of such websites is at your own risk and subject to the terms and conditions of those
                            websites.
                        </p>
                    </div>

                    <div className="pt2 pb2">
                        <Typography variant="h5" fontWeight={600}>
                            Disclaimer
                        </Typography>

                        <p className="pt2">
                            The Website and Materials may include inaccuracies or typographical errors. Appretive makes
                            no representations or warranties about the accuracy, completeness, or suitability of the
                            information contained on the Website.
                        </p>
                        <p className="pt2">
                            All Materials are provided “as is” without warranty of any kind. Appretive disclaims all
                            warranties, whether express or implied, including, but not limited to, implied warranties of
                            merchantability, fitness for a particular purpose, and non-infringement.
                        </p>
                        <p className="pt2">
                            You acknowledge that any reliance on advice, opinions, statements, or information available
                            on the Website shall be at your own risk. Appretive reserves the right to make changes or
                            improvements to the Website and Materials at any time without notice.
                        </p>
                    </div>

                    <div className="pt2 pb2">
                        <Typography variant="h5" fontWeight={600}>
                            Limitation of Liability
                        </Typography>

                        <p className="pt2">
                            Under no circumstances shall Appretive be liable for any direct, indirect, incidental,
                            special, punitive, or consequential damages that result from the use of or inability to use
                            the Website, even if Appretive has been advised of the possibility of such damages.
                        </p>
                    </div>

                    <div className="pt2 pb2">
                        <Typography variant="h5" fontWeight={600}>
                            Indemnification
                        </Typography>

                        <p className="pt2">
                            You agree to indemnify and hold harmless Appretive, its officers, directors, employees, and
                            agents from and against all claims, liabilities, damages, losses, or expenses arising from
                            your use of the Website, violation of these Terms of Use, or infringement of any
                            intellectual property or other rights.
                        </p>
                    </div>

                    <div className="pt2 pb2">
                        <Typography variant="h5" fontWeight={600}>
                            Termination
                        </Typography>

                        <p className="pt2">
                            Appretive reserves the right to terminate or suspend your access to the Website at its sole
                            discretion, without notice, for conduct that violates these Terms or is deemed harmful to
                            Appretive or other users.
                        </p>
                    </div>

                    <div className="pt2">
                        <p className="">
                            If you have any questions regarding these Terms of Use, please contact us at:
                        </p>

                        <p className="flex gap-1 pt1">
                            <MdEmail className="text-2xl" /> Email:{" "}
                            <span className="clr-pm hover:underline cursor-pointer">hr@appretive.com</span>
                        </p>

                        <p className="flex gap-1 pt1">
                            <BiPhone className="text-2xl" /> Phone:{" "}
                            <span className="clr-pm hover:underline cursor-pointer">+91 79842 05484</span>
                        </p>

                        <p className="flex gap-1 pt1">
                            <MdPlace className="text-2xl" /> Address:{" "}
                            <span className="">
                                455, 4th Floor, Royal Arcade, near Sarthana Jakatnaka, Surat, Gujarat 395006
                            </span>
                        </p>
                    </div>

                    {/* <div className="">
                        <Typography
                            className="page-heading mb1 clr-pm"
                            variant="h4"
                            component="h1"
                            fontWeight={600}
                            sx={{ maxWidth: "382px" }}
                        >
                            Terms of Use
                        </Typography>

                        <Typography variant="h5" fontWeight={600} className="card-heading">
                            Terms of Use
                        </Typography>

                        <p className="card-description">Terms of Use</p>
                    </div> */}
                </div>
            </div>
        </div>
    );
};

export default TermOfUse;
